export default "__VITE_ASSET__Dh$07vqa__"